import styled from "styled-components";
import { Container } from "../Container/Container";

const ModalContainer = styled(Container)`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
`;

const ModalBox = styled.div`
  width: 328px;
  background-color: #fff;
  padding: 15px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Modal = ({open, handleClose}) => {
  return (
    <>
      {open ? (
        <ModalContainer onClick={() => handleClose()}>
          <ModalBox>
            <span>링크가 복사되었습니다!</span>
            <span>지금 친구에게 알려주세요!</span>
          </ModalBox>
        </ModalContainer>
      ) : null}
    </>
  );
};
